import type { API } from 'chessboard/api/config/types';
import type { Board } from 'chessboard/model/board/types';
import type { Game } from 'chessboard/model/game/types';

/**
 * Create the isCheck method.
 */
export function createIsCheck(context: API.Context) {
  /**
   * Determine whether or not the current position is check.
   */
  return function isCheck(): Board.SanSquare | false {
    const { game } = context;

    if (game.inCheck()) {
      const pieces: Game.Piece.Collection = context.api.getPieces();

      return pieces.keys().filter((square) => {
        const piece = pieces.get(square);

        return piece.type === 'k' && piece.color === game.turn();
      })[0];
    }

    return false;
  };
}
